import { getPrescriptionEntryList } from './get-prescription-entry-list.js';

function getConfiguratorDocument(content, noAddonsImage) {
    var ref, ref1;
    if (!content) {
        return {
            addOnsStep: {
                noAddonsImage
            },
            prescriptionStep: {},
            prescriptionUploadStep: {},
            packageStep: {}
        };
    }
    const { addOnStepReadMore , packageStepReadMore , prescriptionStepDescription , prescriptionStepImage , prescriptionStepEntryTypes , prescriptionStepMeasure , prescriptionStepRead ,  } = content;
    const entryTypes = getPrescriptionEntryList(prescriptionStepEntryTypes);
    var ref2, ref3;
    return {
        prescriptionStep: {
            entryTypes,
            measureDescription: (ref2 = prescriptionStepMeasure === null || prescriptionStepMeasure === void 0 ? void 0 : (ref = prescriptionStepMeasure.description) === null || ref === void 0 ? void 0 : ref.value) !== null && ref2 !== void 0 ? ref2 : undefined,
            readDescription: (ref3 = prescriptionStepRead === null || prescriptionStepRead === void 0 ? void 0 : (ref1 = prescriptionStepRead.description) === null || ref1 === void 0 ? void 0 : ref1.value) !== null && ref3 !== void 0 ? ref3 : undefined
        },
        prescriptionUploadStep: {
            description: prescriptionStepDescription === null || prescriptionStepDescription === void 0 ? void 0 : prescriptionStepDescription.value,
            image: prescriptionStepImage
        },
        packageStep: {
            readMoreLink: !!(packageStepReadMore === null || packageStepReadMore === void 0 ? void 0 : packageStepReadMore.url) ? packageStepReadMore : undefined
        },
        addOnsStep: {
            readMoreLink: !!(addOnStepReadMore === null || addOnStepReadMore === void 0 ? void 0 : addOnStepReadMore.url) ? addOnStepReadMore : undefined,
            noAddonsImage
        }
    };
}

export { getConfiguratorDocument };
//# sourceMappingURL=get-configurator-document.js.map
